package modysy.menu

import modysy.InputHandler
import modysy.gamestate.{GameState, GameStateManager}
import modysy.view.Color
import org.scalajs.dom
import modysy.view.ImageProvider
import scala.math
import scala.scalajs.js

class MainMenu(
    stateManager: GameStateManager,
    inputs: InputHandler,
    width: Int,
    height: Int
) extends AbstractMenu(inputs, width, height) {

  {
    val startButton = new TextButton(
      width * 0.5,
      0.75 * height,
      "Select Level"
    )
    startButton.fontSize = Math.round(height / 12)
    startButton.colorSelected = Color.Green

    startButton.action = () => {
      stateManager.levelMenu()
    }

    buttons = startButton :: buttons
    buttons.foreach(button => {
      val tmp = button.isEnabled
      button.isEnabled = () => {
        tmp() && (stateManager.gameState == GameState.mainMenu)
      }
    })
    buttons.foreach(button => {
      button.enableTouch(inputs)
    })
  }

  override def render(ctx: dom.CanvasRenderingContext2D): Unit = {

    ctx.fillStyle = Color.Black
    ctx.fillRect(0, 0, width, height)

    ctx.textAlign = "center"

    val titleStart = height * 0.2
    val titleDistance = height * 0.125

    //val fontSize = pxtopt(height)
    ctx.font = height / 8 + "px Arial"
    ctx.fillStyle = Color.Green
    ctx.textBaseline = "alphabetic"
    ctx.fillText(
      "UNDERCOVER AGENTS",
      width / 2,
      titleStart,
      Integer.MAX_VALUE
    )
    ctx.fillStyle = Color.White
    ctx.fillText(
      "and",
      width / 2,
      titleStart + titleDistance,
      Integer.MAX_VALUE
    )
    ctx.fillStyle = "rgb(183,45,183)"
    ctx.fillText(
      "THE FUNKY PORTALS",
      width / 2,
      titleStart + 2 * titleDistance,
      Integer.MAX_VALUE
    )

    var value = scala.math.sin((js.Date.now() % 10000).toInt / 180)

    ImageProvider
      .drawImgFnc(
        ImageProvider.getImage("Green_Agent"),
        (width / 1920 * 500).toInt - 100,
        (height / 1080 * 550).toInt - 110
      )
      .apply(ctx,
             (width / 1920 * 100).toInt,
             (height / 1080 * 550 + height / 1080 * 50 * value).toInt)

    ImageProvider
      .drawImgFnc(
        ImageProvider.getImage("Green_Agent"),
        (width / 1920 * 500).toInt - 100,
        (height / 1080 * 550).toInt - 110
      )
      .apply(ctx,
             (width / 1920 * (1920 - (width / 1920 * 600).toInt)).toInt,
             (height / 1080 * 550 + height / 1080 * 50 * value).toInt)

    super.render(ctx)
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/menu/MainMenu.scala